import { formatCurrency } from "@sa-nu/shared-utils/price";

/** 連泊割引1件 (GraphQL の AccommodationFeeDiscount のうち連泊割引相当の最小形)。 */
export type ConsecutiveNightDiscount = {
  /** 適用閾値。この泊数以上で割引が適用される。 */
  night: number;
  /** 料金修正値 (割引なので負値)。Percentage は整数パーセント / Value は円額。 */
  feeModifier: number;
  feeModifierType: "Value" | "Percentage";
};

/**
 * 連泊割引を「N泊以上の場合、宿泊料金が◯◯OFF」の注意文 (複数行) に整形する。
 * - Percentage: feeModifier は整数パーセント (例: -10) → 「10%OFF」
 * - Value: feeModifier は円額 (例: -1000) → 「¥1,000OFF」
 *
 * feeModifier は割引のため負値で渡る前提だが、表示は絶対値にする。
 */
export function formatConsecutiveNightDiscountNotices(
  discounts: readonly ConsecutiveNightDiscount[],
): string[] {
  return discounts.map((discount) => {
    const amount =
      discount.feeModifierType === "Percentage"
        ? `${Math.abs(discount.feeModifier)}%`
        : formatCurrency(Math.abs(discount.feeModifier));
    return `${discount.night}泊以上の場合、宿泊料金が${amount}OFF`;
  });
}
